const watermark = {
    /**
     * 设置水印
     * @param {*} $el 要添加到的元素位置
     * @param {*} type 0：背景水印，1：水印置顶
     * @param {*} mainContent 可为图片路径（只支持带.png,.jpg,.jpeg后缀的），可为文字内容
     * @param {*} text1 再次要添加的文字内容
     * @param {*} option 其他选项
     */
    set: function ($el, type, mainContent, text1, option) {
        if(!$el){
            return;
        }
        var canvas = document.createElement('canvas')
        canvas.width = option.width || 160;
        canvas.height = option.height || 160;
        canvas.style.display = 'none';
        var shuiyin = canvas.getContext('2d');
        // 控制文字的旋转角度和上下位置
        shuiyin.rotate(-(option.rotate || 0) * Math.PI / 180);
        shuiyin.translate(-(option.rotate || 0), 0)
        //文字颜色
        shuiyin.fillStyle = option.fontColor || "#F5F5F5";
        //文字样式
        shuiyin.font = `400 ${option.fontSize || '16px'} Microsoft JhengHei`;
        if (mainContent.endsWiths(".png") || mainContent.endsWiths(".jpg") || mainContent.endsWiths(".jpeg")) {
            if (text1) {
                shuiyin.fillText(text1, option.fontLeftSize || 0, (option.rotate || 0) + (option.imgSize || 16) + parseInt((option.fontSize || 16))+(option.topSize || 0));
            }
            //绘制图片
            var img = new Image();
            // img.setAttribute("crossOrigin",'Anonymous')
            // img.setAttribute("crossDomain",true)
            // img.setAttribute("Access-Control-Allow-Origin",'http://117.184.59.230:8900')
            //引入图片地址
            img.src = IDM.url.getWebPath(mainContent);
            var that = this;
            img.onload = function () {
                /**画布上绘制图像、画布或视频，
                 * 参数——img：规定要使用的图像、画布或视频
                 * sx：可选。开始剪切的 x 坐标位置
                 * sy：可选。开始剪切的 y 坐标位置
                 swidth：可选。被剪切图像的宽度。
                sheight：可选。被剪切图像的高度。
                x：在画布上放置图像的 x 坐标位置。
                y：在画布上放置图像的 y 坐标位置。
                width：可选。要使用的图像的宽度（伸展或缩小图像）。
                height：可选。要使用的图像的高度（伸展或缩小图像）。**/
                //计算出比例
                var wbl = img.width > img.height ? parseInt((option.imgSize || 16)) / img.width : parseInt((option.imgSize || 16)) / img.height;
                shuiyin.drawImage(img, 0, 0, img.width, img.height, option.imgLeftSize || 0, (option.rotate || 0)+(option.topSize || 0), img.width * wbl, img.height * wbl);
                that.addEl($el, type, mainContent, text1, option, canvas);
            }

        } else {
            shuiyin.fillText(mainContent, option.fontLeftSize || 0, canvas.height / 2 - parseInt(option.fontSize || 16)+(option.topSize || 0));
            if (text1) {
                shuiyin.fillText(text1, option.fontLeftSize || 0, canvas.height / 2 + 5+(option.topSize || 0));
            }
            this.addEl($el, type, mainContent, text1, option, canvas);
        }
        // shuiyin.fillText(text2, canvas.width / 3, canvas.height / 2 + 20);

        //此方法是防止用户通过控制台修改样式去除水印效果
        /* MutationObserver 是一个可以监听DOM结构变化的接口。 */
        // const observer = new MutationObserver(() => {
        //     const wmInstance = document.querySelector('.watermark');
        //     if ((wmInstance && wmInstance.getAttribute('style') !== styleStr) || !wmInstance) {
        //         //如果标签在，只修改了属性，重新赋值属性
        //         if (wmInstance) {
        //             // 避免一直触发
        //             // observer.disconnect();
        //             // console.log('水印属性修改了');
        //             wmInstance.setAttribute('style', styleStr);
        //         } else {
        //             /* 此处根据用户登录状态，判断是否终止监听，避免用户退出后登录页面仍然有水印 */
        //             if (store.getters.token) {
        //                 //标签被移除，重新添加标签
        //                 // console.log('水印标签被移除了');
        //                 document.body.appendChild(watermark)
        //             } else {
        //                 observer.disconnect();
        //             }
        //         }
        //     }
        // })
        // observer.observe(document.body, {
        //     attributes: true,
        //     subtree: true,
        //     childList: true,
        // });
    },
    addEl($el, type, mainContent, text1, option, canvas) {
        if(!$el){
            return;
        }
        /* 新建一个用于填充canvas水印的标签，之所以没有直接在body上添加，
           是因为z-index对个别内容影响，才考虑的不用body */
        var watermark = document.createElement('div')

        const styleStr = `
               position: absolute;
               top:0;
               left:0;
               bottom:0;
               right:0;
               height:100%;
               opacity:${option.opacity===0?0:option.opacity|| 1};
               z-index:${type == 0 ? 0 : 9999999};
               pointer-events:none;
               background-repeat:repeat;
               mix-blend-mode: multiply;
               background-image:url('${canvas.toDataURL("image/png")}')`;
        watermark.setAttribute('style', styleStr);
        watermark.classList.add('idm_watermark')
        if ($el.querySelector(".idm_watermark")) {
            $el.querySelector(".idm_watermark").setAttribute('style', styleStr);
        } else {
            $el.insertBefore(watermark, $el.children[0]);
        }
    },
    close: function ($el) {
        if(!$el){
            return;
        }
        /* 关闭页面的水印，即要移除水印标签 */
        let watermark = $el.querySelector('.idm_watermark')
        watermark&&$el.removeChild(watermark)
    }
}
export default watermark